import { memo } from 'react';
import styled from 'styled-components';

const Flex1 = styled.div`
  display: flex;
  flex: 1;
`;
Flex1.displayName = 'Flex1';

export default memo(Flex1);
